import useRequest from '@/websdk/utils/request';
import { useEffect } from 'react';

export default (function (factory_id) {
  const { isRequestSuccessed, data, exec } = useRequest({
    url: '',
    name: 'workshopPositionGet',
    method: 'GET',
  });
  useEffect(() => {
    if (factory_id && factory_id !== '') {
      exec('/api/Work/shop?factory_id=' + factory_id)
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [factory_id]);
  return [isRequestSuccessed, data || [], exec];
})